module.exports = __webpack_public_path__ + "assets/cryout-creations-fluida.4eaa3f58.svg";